export default __webpack_public_path__ + "static/media/np.db607223.webp";